import React from 'react'
import useTrans from '../../../hooks/useTrans'
import styles from './Alert.module.sass'
import { cn } from '@utils/safeTs'
import { AlertTriangle, Close, Edit } from '@components/icons'

export interface AlertProps {
  variant?: 'info' | 'warning' | 'danger' | 'muted' | 'success'
  icon?: React.ReactNode
  placeholder?: React.ReactNode
  full?: boolean
  closeButton?: boolean
  onClick?: () => void
  onClose?: () => void
  noClick?: boolean
  styleVariant?: 'legacy' | 'background' | 'basic'
  hideDefaultPrefix?: boolean
  className?: string
}

const Alert = ({
  variant = 'danger',
  icon,
  placeholder = 'Notification',
  full,
  closeButton,
  onClick,
  onClose,
  noClick,
  styleVariant = 'legacy',
  hideDefaultPrefix = false,
  className,
}: AlertProps) => {
  const t = useTrans()
  const finalIcon = icon ? icon : styleVariant !== 'legacy' ? <AlertTriangle /> : undefined

  const classNames = cn(
    styles.root, 
    styles[`root--${variant}`], 
    styles[`root--${styleVariant}`], 
    full ? styles['root--full'] : null, 
    onClick && !noClick ? styles['root--clickable'] : null,
    className
  )
  const getContent = () => (
    <>
      {!!finalIcon && <span className={styles.icon}>{finalIcon}</span>}
      <span className={styles.main}>
        {!icon && styleVariant === 'legacy' && !hideDefaultPrefix ? <strong>{t('Attenzione')}: </strong> : <></>}
        {typeof placeholder === 'string' ? (
          <span dangerouslySetInnerHTML={{ __html: placeholder }} />
        ) : (
          <span>{placeholder}</span>
        )}
      </span>
    </>
  )

  return !!onClick && !noClick ? (
    <button className={classNames} onClick={onClick}>
      {getContent()}
      <span className={styles.click}>
        <Edit aria-hidden />
      </span>
    </button>
  ) : (
    <div className={classNames}>
      {getContent()}
      {closeButton && !!onClose && (
        <button type="button" onClick={onClose} className={styles.close} aria-label={t("Chiudi")}>
          <Close aria-hidden />
        </button>
      )}
    </div>
  )
}

export default Alert
